module.exports = __webpack_public_path__ + "static/media/paris-2.baafaf33.jpg";